import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
} from "react-native";
import Header from "../../../component/header";
import Background from "../../../component/background";
import TabbarOption from "../../../component/tabbarOption";

import {
  getFinalAthlete,
  approbationscheck,
  approbationsdeletecheck,
} from "../../../action/authAction";
import { tokenState } from "../../../reducer/recoil";

import { useRecoilState } from "recoil";
import moment from "moment";
import { apiservice } from "../../../service";
import { useIsFocused } from "@react-navigation/native";
const { width, height } = Dimensions.get("window");
export default function index({ navigation, route }) {
  const [data, setData] = useState([]);
  const [Filters, setFilter] = useState([]);
  const [token, setToken] = useRecoilState(tokenState);
  const [gender, setGender] = useState("");
  const [filEvent, setFilEvent] = useState("");
  const [fil, setFil] = useState("");
  const foxus = useIsFocused();

  async function callApi() {
    const response = await getFinalAthlete({
      token: token.token,
      body: parseInt(route.params.competition_id),
      body2: route.params.Approbation_request_by.association_id,
    });

    let Arr = [];
    if (response.result.length > 0) {
      setFilter((val) =>
        val
          .concat(response.result[0].Competition.events_female)
          .concat(response.result[0].Competition.events_male)
      );
    }

    let results = await Promise.all(
      response.result
        ?.sort(
          (a, b) =>
            moment(a?.created_at).valueOf() - moment(b?.created_at).valueOf()
        )
        .map(async (item) => {
          const resposnes = await apiservice({
            path:
              "/athletes/current_score?athlete_id=" +
              item.athlete_id +
              "&competition_id=" +
              route.params.competition_id,
            method: "get",
            token: token.token,
          });

          if (item.official_id != null) {
            Arr = Arr.concat({
              ...item,
              Athlete: item.Officials,
            });
          } else {
            const check = Arr?.filter((e) => {
              return (
                e?.athlete_detail?.first_name ==
                  item?.athlete_detail?.first_name &&
                e?.athlete_detail?.last_name ==
                  item?.athlete_detail?.last_name &&
                e?.athlete_detail?.passport == item?.athlete_detail?.passport
              );
            });
            if (check?.length == 0) {
              Arr = Arr.concat({
                ...item,
              });
            } else {
              if (check?.[0]?.athlete_detail?.image_url == null) {
                Arr = Arr.map((e) =>
                  e?.athlete_detail?.passport ==
                    check?.[0]?.athlete_detail?.passport &&
                  e?.athlete_detail?.first_name ==
                    check?.[0]?.athlete_detail?.first_name &&
                  e?.athlete_detail?.last_name ==
                    check?.[0]?.athlete_detail?.last_name
                    ? {
                        ...e,
                        athlete_detail: {
                          ...e?.athlete_detail,
                          image_url: item?.athlete_detail?.image_url,
                          best_record: item?.athlete_detail?.best_record,
                        },
                      }
                    : { ...e }
                );
              }
            }
          }
        })
    );

    setData(
      Arr?.map((e) =>
        e?.official_id ? { ...e, ...e?.Officials } : { ...e, ...e.Athlete?.[0] }
      )
    );
  }

  useEffect(() => {
    callApi();
  }, [foxus]);

  async function callAPi() {
    const resposne = await approbationscheck({
      body: {
        approbation_id: route.params.approbation_id,
        approbation_type: "Final",
        approbation_status: "Approved",
        competition_id: parseInt(route.params.competition_id),
      },
      token: token.token,
    });

    if (resposne) {
      navigation.navigate("CompetitionStatus");
    }
  }

  async function CancelcallApi1() {
    const response = await approbationsdeletecheck({
      body: {
        approbation_id: route.params.approbation_id,
      },
      token: token.token,
    });
    if (response) {
      navigation.goBack();
    }
  }
  console.log("Arr", data);
  return (
    <View style={styles.container}>
      <Header
        backgroundColorCompetition="#FFFFFF"
        Admin
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            Title={`COMPETITION/${route.params.name}/COUNTRIES STATUS`}
            admin
          />
          <Text style={styles.textTitle}>FINAL ENTRY SUBMIT</Text>
          {Filters.length > 0 && (
            <TabbarOption
              // onfilter={(val) => {
              //   if (val != "Countries") {
              //     setFil(val);
              //   } else {
              //     setFil("");
              //   }
              // }}
              setGender={(val) => {
                if (val != "GENDER") {
                  setGender(val);
                } else {
                  setGender("");
                }
              }}
              onEvent={(val) => {
                setFilEvent(val);
                if (val != "All Events") {
                  setFilEvent(val);
                } else {
                  setFilEvent("");
                }
              }}
              setTypes={(val) => {
                setFil(val);
                if (val != "All Events") {
                  setFil(val);
                } else {
                  setFil("");
                }
              }}
              filterdata={Filters.map((item) => {
                return { label: item, value: item };
              })}
              FinalSub
              buttonTabbar
              association_id={
                route.params.Approbation_request_by.association_id
              }
            />
          )}
          {width >= 1280 && (
            <View style={styles.viewTopic}>
              <Text
                style={[
                  width < 1600 ? styles.textTopicRespons : styles.textTopic,
                  { width: "100%", maxWidth: 120 },
                ]}
              >
                IMAGE
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTopicRespons : styles.textTopic,
                  { width: "15%" },
                ]}
              >
                NAME
              </Text>
              <Text
                numberOfLines={1}
                style={
                  width < 1600 ? styles.textTopicRespons : styles.textTopic
                }
              >
                GENDER
              </Text>
              <Text
                numberOfLines={1}
                style={
                  width < 1600 ? styles.textTopicRespons : styles.textTopic
                }
              >
                BIRTH
              </Text>
              <Text
                numberOfLines={1}
                style={
                  width < 1600 ? styles.textTopicRespons : styles.textTopic
                }
              >
                PASSPORT
              </Text>
              <Text
                numberOfLines={1}
                style={
                  width < 1600 ? styles.textTopicRespons : styles.textTopic
                }
              >
                TYPE
              </Text>
              <Text
                numberOfLines={1}
                style={
                  width < 1600 ? styles.textTopicRespons : styles.textTopic
                }
              >
                EVENTS
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTopicRespons : styles.textTopic,
                  { width: "15%" },
                ]}
              >
                PERSONAL BEST
              </Text>
              <Text
                style={
                  width < 1600 ? styles.textTopicRespons : styles.textTopic
                }
              >
                SEASON BEST
              </Text>
            </View>
          )}
          <FlatList
            data={data
              .filter((item) => {
                try {
                  console.log(
                    "Arr",
                    item.best_record.filter((item) =>
                      item.event.includes(filEvent)
                    ).length > 0
                  );

                  return (
                    item.best_record.filter((item) =>
                      item.event.includes(filEvent)
                    ).length > 0
                  );
                } catch (error) {
                  return true;
                }
              })
              .filter((item) => {
                if (fil == "Athlete") {
                  return item.official_id == null;
                } else if (fil == "Official") {
                  return item.official_id != null;
                } else {
                  return true;
                }
              })}
            scrollEnabled={width < 1280 ? true : false}
            renderItem={({ index, item }) => {
              return width >= 1280 ? (
                <View
                  style={[
                    styles.viewDetail,

                    {
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                      borderTopWidth: index >= 1 ? 0 : 1,
                    },
                  ]}
                >
                  <Image
                    resizeMode={"contain"}
                    style={styles.imgDetail}
                    source={{ uri: item.image_url }}
                  />
                  <Text
                    numberOfLines={1}
                    style={[
                      width < 1600
                        ? styles.textDetailRespons
                        : styles.textDetail,
                      { width: "15%" },
                    ]}
                  >
                    {item.first_name} {item.last_name}
                  </Text>
                  <Text
                    numberOfLines={1}
                    style={
                      width < 1600
                        ? styles.textDetailRespons
                        : styles.textDetail
                    }
                  >
                    {item.gender}
                  </Text>
                  <Text
                    numberOfLines={1}
                    style={
                      width < 1600
                        ? styles.textDetailRespons
                        : styles.textDetail
                    }
                  >
                    {moment(item.Athlete.birth_date).format("DD-MM-YYYY")}
                  </Text>
                  <Text
                    numberOfLines={1}
                    style={
                      width < 1600
                        ? styles.textDetailRespons
                        : styles.textDetail
                    }
                  >
                    {item.passport}
                  </Text>
                  <Text
                    numberOfLines={1}
                    style={
                      width < 1600
                        ? styles.textDetailRespons
                        : styles.textDetail
                    }
                  >
                    {item.official_id != null ? "Official" : "Athlete"}
                  </Text>
                  <View style={{ width: "10%" }}>
                    {item.best_record != null &&
                      item.best_record.map((e) => (
                        <Text
                          numberOfLines={1}
                          style={[
                            width < 1600
                              ? styles.textDetailRespons
                              : styles.textDetail,
                            { width: "100%" },
                          ]}
                        >
                          {e.event}
                        </Text>
                      ))}
                  </View>

                  <View style={{ width: "15%" }}>
                    {item.best_record != null &&
                      item.best_record.map((e) => (
                        <>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "100%" },
                            ]}
                          >
                            {e.event}
                          </Text>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "100%" },
                            ]}
                          >
                            {e.personal_best_stat}
                          </Text>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "100%" },
                            ]}
                          >
                            {e.personal_best_date}
                          </Text>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "100%" },
                            ]}
                          >
                            {e.personal_best_venue}
                          </Text>
                        </>
                      ))}
                  </View>
                  <View style={{ width: "10%" }}>
                    {item.best_record != null &&
                      item.best_record.map((e) => (
                        <>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "100%" },
                            ]}
                          >
                            {e.event}
                          </Text>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "100%" },
                            ]}
                          >
                            {e.season_best_stat}
                          </Text>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "100%" },
                            ]}
                          >
                            {e.season_best_date}
                          </Text>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "100%" },
                            ]}
                          >
                            {e.season_best_venue}
                          </Text>
                        </>
                      ))}
                  </View>
                </View>
              ) : (
                <View
                  style={[
                    stylesResponsive.viewDetail,

                    {
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                      borderTopWidth: index >= 1 ? 0 : 1,
                    },
                  ]}
                >
                  <Image
                    resizeMode={"contain"}
                    style={styles.imgDetail}
                    source={item.img}
                  />
                  <View
                    style={{
                      width: "60%",
                      marginLeft: 10,
                    }}
                  >
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTopic, { marginTop: 0 }]}
                    >
                      NAME
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.first_name} {item.last_name}
                    </Text>{" "}
                    <Text numberOfLines={1} style={stylesResponsive.textTopic}>
                      GENDER
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textDetail}>
                      {item.gender}
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textTopic}>
                      BIRTH
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textDetail}>
                      {item.Birth}
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textTopic}>
                      PASSPORT
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textDetail}>
                      {item.Passport}
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textTopic}>
                      TYPE
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textDetail}>
                      {item.Type}
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textTopic}>
                      EVENTS
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textDetail}>
                      {item.Events == "" ? "-" : item.Events}
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textTopic}>
                      PERSONAL BEST
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.BestTimePersonal == ""
                        ? "-"
                        : item.BestTimePersonal}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.DatePersonal}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.CountryPersonal}
                    </Text>
                    <Text numberOfLines={1} style={stylesResponsive.textTopic}>
                      SEASON BEST
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.BestTimeSeason == "" ? "-" : item.BestTimeSeason}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.DateSeason}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textDetail]}
                    >
                      {item.CountrySeason}
                    </Text>
                  </View>
                </View>
              );
            }}
          />
          {route.params.approbation_status !== "Approved" ? (
            <View
              style={
                width >= 1280 ? styles.viewButton : stylesResponsive.viewButton
              }
            >
              <TouchableOpacity
                onPress={() => {
                  callAPi();
                }}
                style={styles.buttonConfirm}
              >
                <Text style={[styles.textbutton, { color: "#2BB165" }]}>
                  CONFIRM
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  CancelcallApi1();
                }}
                style={styles.buttonCancel}
              >
                <Text style={[styles.textbutton, { color: "#FF4E4E" }]}>
                  CANCEL
                </Text>
              </TouchableOpacity>
            </View>
          ) : (
            <View
              style={
                width >= 1280 ? styles.viewButton : stylesResponsive.viewButton
              }
            >
              <TouchableOpacity
                onPress={() => {
                  CancelcallApi1();
                }}
                style={styles.buttonCancel}
              >
                <Text style={[styles.textbutton, { color: "#FF4E4E" }]}>
                  CANCEL
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  navigation.goBack();
                }}
                style={[styles.buttonConfirm, { marginLeft: 15 }]}
              >
                <Text style={[styles.textbutton, { color: "#2BB165" }]}>
                  OK
                </Text>
              </TouchableOpacity>
            </View>
          )}
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  textTitle: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginLeft: 30,
    marginTop: 36,
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  textDetailRespons: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  buttonConfirm: {
    width: 108,
    height: 43,
    backgroundColor: "#B2FFAC",
    borderWidth: 1,
    borderColor: "#2BB165",
    justifyContent: "center",
    borderRadius: 10,
  },
  textbutton: {
    fontSize: 14,
    fontFamily: "Prompt",
    alignSelf: "center",
  },
  buttonCancel: {
    width: 108,
    height: 43,
    backgroundColor: "#FFBEBE",
    borderWidth: 1,
    borderColor: "#FF4E4E",
    justifyContent: "center",
    marginLeft: 35,
    borderRadius: 10,
  },
  viewDetail: {
    flexDirection: "row",
    paddingHorizontal: 38.5,
    borderTopColor: "#9cbee7",
    borderBottomWidth: 1,
    borderBottomColor: "#9cbee7",
    height: 147,
    alignItems: "center",
    justifyContent: "space-between",
  },
  imgDetail: {
    width: "100%",
    maxWidth: 120,
    height: 120,
    borderRadius: 5,
  },
  textTopic: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  textTopicRespons: {
    fontSize: 13,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },

  viewTopic: {
    flexDirection: "row",
    marginTop: 35,
    paddingHorizontal: 38.5,
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#9cbee7",
    paddingBottom: 5.5,
  },
  viewButton: {
    flexDirection: "row",
    marginVertical: 43,
    marginLeft: 38.5,
  },
});
const stylesResponsive = StyleSheet.create({
  viewDetail: {
    flexDirection: "row",
    paddingHorizontal: 38.5,
    borderTopColor: "#9cbee7",
    borderBottomWidth: 1,
    borderBottomColor: "#9cbee7",
    justifyContent: "space-betw000een",
    paddingVertical: 20,
  },
  textDetail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textTopic: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 10,
  },
  viewButton: {
    flexDirection: "row",
    marginVertical: 20,
    alignSelf: "center",
  },
});
